import type { UseFormReturnType } from "@mantine/form";

export type StepFields<T> = Record<number, (keyof T)[]>;

export function validateFormStepFields<T>(stepFields: StepFields<T>, form: UseFormReturnType<T>) {
  return (step: number) => {
    return stepFields[step].every((field) => {
      const value = form.values[field];

      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      return value !== undefined && value !== null;
    });
  };
}
